import React, { Component } from 'react'
import { connect } from 'react-redux'

import { DealsWidget } from '.'
import { CenteredContent } from 'containers'
import { Authorization } from 'utils/AuthorizationUtils'
import StyleSheet from 'styles'

const ACCEPTED_FILTERS = ['active', 'mine', 'upcoming', 'past']

export class Deals extends Component {

  get filter() {
    const f = this.props.match.params.filter
    return ACCEPTED_FILTERS.includes(f) ? f : 'active'
  }

  get widgetFilter() {
    switch (this.filter) {
      case 'active':
        return { active: true }
      case 'mine':
        return { participant_id: Authorization.user.id }
      case 'upcoming':
        return { upcoming: true }
      case 'past':
        return { closed: true }
      default:
        throw new Error(`Don't know how to handle filter: ${this.filter}`)
    }
  }

  get renderer(){
    switch(this.filter){
      case 'past':
        return 'roi_table'
      default:
        return 'list'
    }
  }

  get title() {
    return `deals.${this.filter}`
  }

  get secondaryFilters() {
    if(this.filter === 'mine') {
      return [
        {label: 'deals.mine.all',    filter: {  }},
        {label: 'deals.mine.active', filter: { active: true }},
        {label: 'deals.mine.past',   filter: { closed: true }}
      ]
    }

    return []
  }

  render () {
    return (
      <div>
        <CenteredContent>
          <div className={styles.content}>
            <DealsWidget renderer={this.renderer} key={this.filter} name='dealsView' title={this.title}
              widgetFilter={this.widgetFilter} secondaryFilters={this.secondaryFilters}
              pageSize={10} renderPaging={true}/>
          </div>
        </CenteredContent>
      </div>
    )
  }
}

const styles = StyleSheet({
  wrapper: {
    paddingTop: '50px'
  },
  content: {
    paddingTop: 30,
  }
})

export default connect(({dealSheets}) => dealSheets)(Deals)